import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconKeyboardDoubleArrowRightLine = ({
  width,
  height,
  fill = 'currentColor',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.056 12 5.998 7.927a.745.745 0 0 1-.22-.514.698.698 0 0 1 .22-.54.718.718 0 0 1 .527-.217c.206 0 .382.072.527.217l4.494 4.494a.831.831 0 0 1 .256.633.832.832 0 0 1-.256.633l-4.494 4.494a.745.745 0 0 1-.515.22.698.698 0 0 1-.539-.22.718.718 0 0 1-.217-.527c0-.206.072-.382.217-.527L10.056 12Zm6.35 0-4.058-4.073a.744.744 0 0 1-.22-.514.697.697 0 0 1 .22-.54.718.718 0 0 1 .527-.217c.206 0 .382.072.527.217l4.494 4.494a.83.83 0 0 1 .256.633.832.832 0 0 1-.256.633l-4.494 4.494a.745.745 0 0 1-.514.22.698.698 0 0 1-.54-.22.718.718 0 0 1-.217-.527c0-.206.072-.382.217-.527L16.406 12Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconKeyboardDoubleArrowRightLine;
